import { useEffect, useRef } from 'react';
var createRootElement = function (id) {
    var rootElement = document.createElement('div');
    rootElement.setAttribute('id', id);
    return rootElement;
};
var addRootElement = function (rootElement) {
    document.body.insertBefore(rootElement, document.body.lastElementChild.nextElementSibling);
};
export default (function (id) {
    if (id === void 0) { id = 'modal-root'; }
    var rootElemRef = useRef(null);
    var getRootElem = function () {
        if (rootElemRef.current === null) {
            rootElemRef.current = document.createElement('div');
        }
        return rootElemRef.current;
    };
    var rootElem = getRootElem();
    useEffect(function () {
        var existingParent = document.getElementById(id);
        var parent = existingParent || createRootElement(id);
        if (!existingParent) {
            addRootElement(parent);
        }
        parent.appendChild(rootElem);
        return function () {
            rootElem.remove();
            if (parent.childNodes.length === 0) {
                parent.remove();
            }
        };
    }, [id, rootElem]);
    return rootElem;
});
//# sourceMappingURL=usePortal.js.map